export const fileUtils = {
  downloadFile: (data, filename, mime, bom) => {
    const blobData = typeof bom !== 'undefined' ? [bom, data] : [data];
    const blob = new Blob(blobData, {
      type: mime || 'application/octet-stream',
    });
    const blobURL = window.URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();

    // Fixes "webkit blob resource error 1"
    setTimeout(function() {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }, 0);
  },
  base64toBlob: (b64Data, fileName = 'file', type = 'image/png') => {
    const imageContent = atob(b64Data);
    const buffer = new ArrayBuffer(imageContent.length);
    const uint8Array = new Uint8Array(buffer);

    for (let n = 0; n < imageContent.length; n++) uint8Array[n] = imageContent.charCodeAt(n)
    const blob = new Blob([buffer], { type });
    
    return new File([blob], fileName, { lastModified: new Date().getTime(), type });
  }
};
